<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-justify-between wf-items-center">
    <span
      class="wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide"
    >Icon Color</span>
    <EditorPicker
      picker-classes="wf-top-0 wf-mt-8 wf-right-0"
      v-model="color"
    />
  </li>
</template>

<script>
  import EditorPicker from '../components/EditorPicker'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  import { TextColorStyle } from '../styles/ColorStyles'
  export default MenuStyleProperty.extend({
    components: {EditorPicker},
    computed: {
      color: {
        get() {
          let textColor = this.elementStyles(this.styles)[this.device].find(deviceStyle => deviceStyle.property === TextColorStyle.property)
          if (! textColor) {
            textColor = {...TextColorStyle, value: '#000000', touched: false}
            this.addToArray(this.module, [textColor], this.styles, this.device, {}, true, this.parentModule)
          }
          return textColor.value
        },
        set(value) {
          let rgba = `rgba(${value.rgba.r}, ${value.rgba.g}, ${value.rgba.b}, ${value.rgba.a})`
          let textColor = {...TextColorStyle, value: rgba, touched: false}
          this.addToArray(this.module, [textColor], this.styles, this.device, {}, true, this.parentModule)
        }
      },
    }
  })
</script>
